// Core
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

// Instruments
import routerHistory from 'init/history';
import { queriesReducer as queries } from 'bus/queries/reducer';
import { geoReducer as geo } from 'bus/geo/reducer';
import { authReducer as auth } from 'bus/auth/reducer';
import { searchReducer as search } from 'bus/search/reducer';
import { hotelsReducer as hotels } from 'bus/hotels/reducer';
import { offersReducer as offers } from 'bus/offers/reducer';
import { orderReducer as order } from 'bus/order/reducer';
import { servicesReducer as services } from 'bus/services/reducer';
import { uiReducer as ui } from 'bus/ui/reducer';
import { reviewsReducer as reviews } from 'bus/reviews/reducer';
import { historyReducer as history } from 'bus/history/reducer';
import { compareReducer as compare } from 'bus/compare/reducer';
import { hotReducer as hot } from 'bus/hot/reducer';

export const rootReducer = combineReducers({
    router: connectRouter(routerHistory),
    queries,
    geo,
    auth,
    search,
    services,
    hotels,
    offers,
    ui,
    order,
    reviews,
    history,
    compare,
    hot,
});
